<script>
import FilterCompaniesTab from "@/Forms/Filters/FilterCompaniesTab.vue";
import FilterRolesTab from "@/Forms/Filters/FilterRolesTab.vue";
import FilterAssetTypesTab from "@/Forms/Filters/FilterAssetTypesTab.vue";
import FilterDeviceManufacturersTab from "@/Forms/Filters/FilterDeviceManufacturersTab.vue";
import FilterDeviceTypesTab from "@/Forms/Filters/FilterDeviceTypesTab.vue";
import FilterDeviceModelsTab from "@/Forms/Filters/FilterDeviceModelsTab.vue";
import FilterDeviceRevisionsTab from "@/Forms/Filters/FilterDeviceRevisionsTab.vue";
import FilterRegulationsTab from "@/Forms/Filters/FilterRegulationsTab.vue";
import FilterVehicleManufacturersTab from "@/Forms/Filters/FilterVehicleManufacturersTab.vue";
import FilterFirmwareTypesTab from "@/Forms/Filters/FilterFirmwareTypesTab.vue";

export default {
  name: "EditFiltersForm",
  components: {
    FilterRolesTab, 
    FilterCompaniesTab,
    FilterAssetTypesTab,
    FilterDeviceManufacturersTab,
    FilterDeviceTypesTab,
    FilterDeviceModelsTab,
    FilterDeviceRevisionsTab,
    FilterRegulationsTab,
    FilterVehicleManufacturersTab,
    FilterFirmwareTypesTab
  },
  data() {
    return {
      activeTabs: [],
      tabs: [
        {
          header: this.$t('forms.filters.edit_filters_form.headers.asset_types'), 
          component: FilterAssetTypesTab, 
          key: 'asset_type_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.companies'), 
          component: FilterCompaniesTab, 
          key: 'company_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.device_manufacturers'), 
          component: FilterDeviceManufacturersTab, 
          key: 'device_manufacturer_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.device_types'), 
          component: FilterDeviceTypesTab, 
          key: 'device_type_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.device_models'), 
          component: FilterDeviceModelsTab, 
          key: 'device_model_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.device_revisions'), 
          component: FilterDeviceRevisionsTab, 
          key: 'device_revision_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.firmware_types'), 
          component: FilterFirmwareTypesTab, 
          key: 'firmware_type_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.regulations'), 
          component: FilterRegulationsTab, 
          key: 'regulation_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.roles'), 
          component: FilterRolesTab, 
          key: 'role_ids'
        },
        {
          header: this.$t('forms.filters.edit_filters_form.headers.vehicle_manufacturers'), 
          component: FilterVehicleManufacturersTab, 
          key: 'vehicle_manufacturer_ids'
        },
      ],
      filters: {},
      passThrough: {
        tabView: {
          root: {
            class: ['flex flex-row divide-x h-[30rem] min-h-[30rem]']
          },
          nav: {
            class: ['flex flex-col']
          },
          navContent: {
            class: ['overflow-x-hidden overflow-y-scroll h-full'],
          },
          navContainer: {
            class: ['w-56'],
          },
          panelContainer: {
            class: ['flex-1 overflow-scroll bg-white']
          },
        },
        tabPanel: {
          content: {
            class: []
          },
          header: {
            class: ['bg-surface-50 border-0']
          },
          headerAction: {
            class: ['!border-0 !rounded-none']
          },
          headerTitle: {
            class: ['pl-3'],
          },
        }
      }
    }
  },
  computed: {
    availableTabs() {
      return this.tabs.filter(tab => this.activeTabs.includes(tab.key));
    }
  },
  inject: ['dialogRef'],
  methods: {
    onCancelClick() {
      this.dialogRef.close();
    },
    onSaveClick() {
      console.log(this.$t('forms.filters.edit_filters_form.messages.confirming_chosen_filters'));
      this.dialogRef.close({ filter: this.filters });
    },
    onClearAllClick() {
      let cleanObj = {}

      for (const [key, value] of Object.entries(this.filters)) {
        if (Array.isArray(value)){
          cleanObj[key] = [];
        } else {
          cleanObj[key] = null;
        }
      }

      this.filters = cleanObj;
    },
    getTabHeader(tab) {
      const chosenFilters = this.filters[tab.key]?.length;
      return tab.header + (chosenFilters ? ` (${chosenFilters})` : '');
    }
  },
  mounted() {
    this.filters = {...this.dialogRef.data.filter} || {};
    this.activeTabs = Object.keys(this.filters);
  },
}
</script>

<template>
  <div class="border-t border-surface-200 -mx-6 bg-surface-50 h-full grid grid-rows-2">

    <!-- Tabs -->
    <div class="flex-1 flex flex-col h-full row-span-full">
      <TabView :pt="passThrough.tabView" lazy scrollable>
        <TabPanel v-for="tab in availableTabs" :header="getTabHeader(tab)" :pt="passThrough.tabPanel">
          <Component :is="tab.component" v-model="filters[tab.key]" :pt="passThrough.tabPanel"/>
        </TabPanel>
      </TabView>
    </div>

    <!-- Footer -->
    <div class="flex items-stretch justify-between bg-white border-t border-surface-200 p-3 pb-0 gap-3">
      <div class="flex-1">
        <Button 
          :label="$t('forms.filters.edit_filters_form.buttons.clear_all')" 
          severity="secondary" 
          size="large" 
          text 
          @click="onClearAllClick"
        />
      </div>

      <Button 
        :label="$t('forms.filters.edit_filters_form.buttons.cancel')" 
        severity="secondary" 
        size="large" 
        text 
        @click="onCancelClick"
      />
      <Button 
        :label="$t('forms.filters.edit_filters_form.buttons.apply_filters')" 
        size="large" 
        @click="onSaveClick"
      />
    </div>
  </div>
</template>

<style scoped>

</style>